module.exports = __webpack_public_path__ + "media/images/home-b4dd605b90064eee275e0bfe92b00fc4.svg";